module.exports = __webpack_public_path__ + "img/CS-Small-Profiles.0837dbba.jpg";